// Shared tab model used by the forum renderer and the admin editor.

export const TAB_TYPES = ['home', 'tags', 'search', 'notifications', 'profile', 'new-discussion', 'login', 'logo', 'favicon', 'link'];

// Mirrors the original hardcoded bar, so behaviour is unchanged out of the box.
export const DEFAULT_TABS = [{
  type: 'home',
  icon: 'far fa-comments',
  label: 'Home',
  visibility: 'all'
}, {
  type: 'tags',
  icon: 'fas fa-tag',
  label: 'Tags',
  visibility: 'all'
}, {
  type: 'new-discussion',
  icon: 'fas fa-plus',
  label: '',
  visibility: 'in',
  raised: true
}, {
  type: 'notifications',
  icon: 'fas fa-bell',
  label: 'Notifications',
  visibility: 'in'
}, {
  type: 'profile',
  visibility: 'in'
}, {
  type: 'login',
  icon: 'fas fa-sign-in-alt',
  label: 'Log in',
  visibility: 'out'
}];
flarum.reg.add('ernestdefoe-mobile-tab', 'common/tabs', { TAB_TYPES: TAB_TYPES,DEFAULT_TABS: DEFAULT_TABS, });